import request from '@/utils/request'



/**
 * 个人详情
 * @param {*} data
 * id
 */
export function adminUsersRead(data) {
  return request({
    url: 'user/read',
    method: 'post',
    data: data
  })
}



/**
 * 修改密码
 * @param {*} data
 * id
 * old_pwd
 * new_pwd
 */
export function adminUsersResetPassword(data) {
  return request({
    url: 'admin/users/resetPassword',
    method: 'post',
    data: data
  })
}
